import { Component, ViewContainerRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { ContestService } from '../../../services';
import { FilterModel, FilterResponseModel } from '../../../models';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'ContentSearchResult',
    templateUrl: './content.search.result.component.html'
})

export class ContentSearchResultComponent {
    @BlockUI('container-search-result') blockUI: NgBlockUI;

    filterModel: FilterModel = new FilterModel();
    filterResponse: FilterResponseModel = new FilterResponseModel();
    isComponentInitiated = false;

    resultSet: any = [];
    pageCount: number;
    totalRecords: number;
    pageSize = 16;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private contestService: ContestService) {
        this.toastr.setRootViewContainerRef(this.vcr);
        this.route.queryParams.subscribe(params => {
            if (params['q']) {
                this.filterModel.filterKey = params['q'];
            } else {
                this.filterModel.filterKey = null;
            }
        });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.filterContests(1);
            }
        });
    }


    filterContests(page: number) {
        this.blockUI.start();
        this.filterModel.pageNumber = page;
        this.filterModel.perPage = this.pageSize;
        this.pageCount = page;
        this.contestService.filter(this.filterModel)
            .subscribe(
                data => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    Object.assign(this.filterResponse, data);
                    this.filterResponse.resultSet.map((item) => {
                        item.deadline = this.appUtils.getFormattedDate(item.deadline, null);
                    });
                },
                error => {
                    this.blockUI.stop();
                    this.isComponentInitiated = true;
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/components/contest/search-result/content.search.result.component.ts